export default "__VITE_ASSET__tZV9lLbx__"